import { store } from '../store';
import {
    GET_ALL_PRODUCTS,
    GET_ALL_PRODUCTS_SUCCESS,
    GET_ALL_PRODUCTS_FAILURE,
    GET_RECOMMENDED_RESULTS,
    GET_RECOMMENDED_RESULTS_SUCCESS,
    GET_RECOMMENDED_RESULTS_FAILURE,
} from '../../constants';
import {
    client as graphQlClient,
    GET_ALL_PRODUCTS as GET_ALL_PRODUCTS_QUERY,
    PULL_PRODUCT_RECOMMENDATIONS,
} from '../../graphql';
import { productConfiguration } from '../../config';
import {
    mapRecommendations,
    mapRecommendationQuestionRequest,
    sortRecommendationAlphabetically,
} from '../../utils';

export const getAllProductsSuccess = (allProducts) => ({
    type: GET_ALL_PRODUCTS_SUCCESS,
    allProducts,
    error: null,
});

export const getAllProductsFailure = (error) => ({
    type: GET_ALL_PRODUCTS_FAILURE,
    error,
});

export const getRecommendedResultsSuccess = (recommendedResults) => ({
    type: GET_RECOMMENDED_RESULTS_SUCCESS,
    recommendedResults,
    error: null,
});

export const getRecommendedResultsFailure = (error) => ({
    type: GET_RECOMMENDED_RESULTS_FAILURE,
    error,
});

export const getAllProducts = (productID) => async (dispatch) => {
    try {
        dispatch({ type: GET_ALL_PRODUCTS, isLoading: true });
        const {
            questionnaireReducer: { sessionID },
        } = store.getState();

        await graphQlClient
            .query({
                query: GET_ALL_PRODUCTS_QUERY,
                variables: {
                    productID: productConfiguration[productID],
                    sessionID,
                    customerID: sessionID,
                },
                fetchPolicy: 'no-cache',
            })
            .then((data) => {
                const {
                    data: {
                        getAllAvailableProducts: {
                            recommendedProducts: allProducts,
                        },
                    },
                } = data;

                allProducts.sort(sortRecommendationAlphabetically);

                dispatch(
                    getAllProductsSuccess(
                        mapRecommendations(allProducts, false),
                    ),
                );
            });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        dispatch(getRecommendedResultsFailure(err));
    }
};

export const getRecommendedResults =
    (productID) => async (dispatch) => {
        try {
            dispatch({
                type: GET_RECOMMENDED_RESULTS,
                isLoading: true,
            });
            const {
                questionnaireReducer: {
                    sessionID,
                    questionnaireState,
                },
            } = store.getState();

            await graphQlClient
                .mutate({
                    mutation: PULL_PRODUCT_RECOMMENDATIONS,
                    variables: {
                        productID: productConfiguration[productID],
                        sessionID,
                        customerID: sessionID,
                        selectedQuestionnaire:
                            mapRecommendationQuestionRequest(
                                questionnaireState,
                            ),
                    },
                    fetchPolicy: 'no-cache',
                })
                .then((data) => {
                    const {
                        data: {
                            pullProductRecommendations: {
                                recommendedProducts:
                                    recommendedResults,
                            },
                        },
                    } = data;

                    recommendedResults.sort(
                        sortRecommendationAlphabetically,
                    );

                    dispatch(
                        getRecommendedResultsSuccess(
                            mapRecommendations(
                                recommendedResults,
                                true,
                            ),
                        ),
                    );
                });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
            dispatch(getRecommendedResultsFailure(err));
        }
    };
